import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
	FormControl,
	FormGroup,
	Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { DureeExecutionByType, PeriodeExecutionByType, Prestation, PrestationStatut, PrestationType, QualificationEtat } from 'src/app/shared/models/prestation';
import { BonCommande } from 'src/app/shared/models/bonCommande';

@Component({
	selector: 'app-prestation-modal-ajout',
	templateUrl: './prestation-modal-ajout.component.html',
	styleUrls: ['./prestation-modal-ajout.component.scss']
})
export class PrestationModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	@Output() updateListing = new EventEmitter();
	
	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	public prestationStatutEnum = PrestationStatut;
	public qualificationEtatEnum = QualificationEtat;

	formAjout: FormGroup = new FormGroup(
		{
			typePrestation: new FormControl('', Validators.required,),
			dateDepot: new FormControl<Date>(null),
			dateDebut: new FormControl<Date>(null, Validators.required,),
			dateFin: new FormControl<Date>(null),
			dateLimite: new FormControl<Date>(null, Validators.required,),
			dateValidation: new FormControl<Date>(null),
			//dateLimite: new FormControl<Date>({value: null, disabled: true}, Validators.required),
			statut: new FormControl(''),
			natureAbandon: new FormControl(''),
			commentaireAbandon: new FormControl(''),
			etatQualification: new FormControl(''),
			beneficiaire: new FormControl('', Validators.required,),
			bonCommande: new FormControl(''),
			intervenant: new FormControl(),
			intervenantModule: new FormControl(),
			raison: new FormControl(''),
			imperatifs: new FormControl(''),
			situation: new FormControl(''),
			duree: new FormControl('', Validators.required,),
			dureePrevisionnelle: new FormControl('', Validators.required,),
			periode: new FormControl('', Validators.required,),
			origineDemande: new FormControl(''),
			prescripteur: new FormControl(''),
			prescripteurContact: new FormControl(''),
			raisonDemandeAccomp: new FormControl(''),
			objectifPro: new FormControl(''),
			metiersCibles: new FormControl(''),
			typeAccompagnement: new FormControl(''),
			difficultes: new FormControl(''),
			besoins: new FormControl(''),
			origineHandicap: new FormControl(''),
			rapportHandicap: new FormControl(''),
			logement: new FormControl(''),
			sante: new FormControl(''),
			situationFinanciere: new FormControl(''),
			situationFamiliale: new FormControl(''),
			smBilan: new FormControl(''),
			smAccomp: new FormControl(''),
			deMetiersCibles: new FormControl(''),
			deProjetPro: new FormControl(''),
			deRuptureParcours: new FormControl(''),
			deBesoinsIdent: new FormControl(''),
			eeLimites: new FormControl(''),
			eeQuestEmploi: new FormControl(''),
			eeBesoinsAdapt: new FormControl(''),
			eePbAccess: new FormControl(''),
			eeAccompDejaMene: new FormControl(''),
			eeNomEntreprise: new FormControl(''),
			eeNomContactEntreprise: new FormControl(''),
			eePrenomContactEntreprise: new FormControl(''),
			eeMailContactEntreprise: new FormControl(''),
			eeTelContactEntreprise: new FormControl(''),
			eeSyntheseSitEmployeur: new FormControl(''),
			eeHoraires: new FormControl(''),
			eeFichePoste: new FormControl(''),
			efLimiteCapacite: new FormControl(''),
			efQuestionnement: new FormControl(''),
			efAccompDejaMene: new FormControl(''),
			efAccessibilite: new FormControl(''),
			efTypeFormation: new FormControl(''),
			efBesoinsAt: new FormControl(''),
			efNomCentreFormation: new FormControl(''),
			efPlanning: new FormControl(''),
			efRemarqueRef: new FormControl(''),
			syntheseInfo: new FormControl(''),
			premieresOrientations: new FormControl(''),
			langage: new FormControl(''),
			praxie: new FormControl(''),
			memoire: new FormControl(''),
			fonctExecutif: new FormControl(''),
			fonctAttent: new FormControl(''),
			cognitionSociale: new FormControl(''),
			comportement: new FormControl(''),
			preconisations: new FormControl(''),
			observations: new FormControl(''),

			tauxReconnaissance: new FormControl(),
			niveauEtude: new FormControl(),
			niveauQualification: new FormControl(),
			statutProfessionnel: new FormControl(),
			eligibiliteBeneficiaire: new FormControl(),
			doleances: new FormControl(''),
			environnementSocial: new FormControl(''),
			//environnementSocial: new FormControl({value: '', disabled: true}),
			// orientationMdph: new FormControl(''),
			// freins: new FormControl(''),
			// ressources: new FormControl(''),
			// contraintes: new FormControl(''),
			// propositionsActions: new FormControl(''),
			// planActionPerso: new FormControl(''),
			analyseAdequation: new FormControl(''),
			recommandantions: new FormControl(''),
			statutBeneficiaire: new FormControl(''),
			numeroCommande: new FormControl(''),

			// datePrescription: new FormControl(''),
			// datePremierContact: new FormControl(''),
			// datePremierRv: new FormControl(''),
			// dateS3: new FormControl(''),
			// dateS6: new FormControl(''),
			// preconisationsProposes: new FormControl(''),
			// comprehensionPreco: new FormControl(''),
			// description: new FormControl(''),
			// complements: new FormControl(''),
			// nomS3: new FormControl(''),
			// prenomS3: new FormControl(''),
			// fonctionS3: new FormControl(''),
			// preconisationMeoS3: new FormControl(''),
			// descriptionS3: new FormControl(''),
			// freinS3: new FormControl(''),
			// reponseS3: new FormControl(''),
			// nomS6: new FormControl(''),
			// prenomS6: new FormControl(''),
			// fonctionS6: new FormControl(''),
			// preconisationMeoS6: new FormControl(''),
			// descriptionS6: new FormControl(''),
			// freinS6: new FormControl(''),
			// reponseS6: new FormControl(''),

			dateContactPrescripteur: new FormControl(''),
			dateContactPersonne: new FormControl(''),
			dateContactEmployeur: new FormControl(''),
			meoSolutions: new FormControl(''),
			precoNonMeo: new FormControl(''),
			raisons: new FormControl(''),
			propositionAs: new FormControl(''),
			propositionAutre: new FormControl(''),
			propositionAutreDetails: new FormControl(''),
			heuresDeclarees: new FormControl(''),

			ressourcesFinancieres: new FormControl(''),
			niveauRendement: new FormControl(''),
			satisfaction: new FormControl(''),
			stress: new FormControl(''),
			forces: new FormControl(''),
			attention: new FormControl(''),
			gnosies: new FormControl(''),
			pointVigilence: new FormControl(''),
			ppIntitulePoste: new FormControl(''),
			ppDescriptionPosteBenef: new FormControl(''),
			ppDescriptionPosteOf: new FormControl(''),
			ppEntrepriseVise: new FormControl(''),
			idQualification: new FormControl(),
			showServiceChefFile: new FormControl(),
			serviceChefFile: new FormControl(),

			dateDebutContrat: new FormControl<Date>(null),
			dateFinContrat: new FormControl<Date>(null),
			salarieEntreprise: new FormControl(),
			accordEmployeur: new FormControl(),
			arretTravail: new FormControl(),
			agentFonctPub: new FormControl(),
			accordHandicap: new FormControl(),
		}
	);

	user: User;
	prestation = new Prestation();

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		//this.prestation.statut = this.prestationStatutEnum.COURS;
		console.log(this.prestation);
		this.updateVolHorairePrevisionnel(this.prestation);
		switch(this.prestation.typePrestation) { 
			case PrestationType.QD: { 
				this.prestation.etatQualification = this.qualificationEtatEnum.BROUILLON;
				this.facade.qualificationService.addQualification(this.prestation).subscribe({
					next: (val) => { 
						if(this.prestation.modules?.length > 0){
							this.prestation.modules.forEach((currentValue) => {
								switch(currentValue) { 
									case PrestationType.AC: {
										let ac = new Prestation();
										ac.statut = this.prestationStatutEnum.COURS;
										ac.beneficiaire = this.prestation.beneficiaire;
										ac.statutBeneficiaire = this.prestation.statutBeneficiaire;
										ac.typePrestation = this.prestation.typePrestation;
										ac.dateDebut = this.prestation.dateDebut
										ac.metiersCibles = this.prestation.metiersCibles;
										ac.service = this.prestation.service;
										ac.serviceChefFile = this.prestation.serviceChefFile;
										ac.bonCommande = this.prestation.bonCommande;
										ac.intervenant = this.prestation.intervenantModule;
										ac.numeroCommande = this.prestation.numeroCommande;
										ac.prescripteur = this.prestation.prescripteur;
										ac.prescripteurContact = this.prestation.prescripteurContact;
										ac.periode = PeriodeExecutionByType[PrestationType.AC];
										ac.duree = DureeExecutionByType[PrestationType.AC];
										if(this.prestation.dateDebut != null){
											let calculatedDateLimite = new Date(this.prestation.dateDebut);
											ac.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.AC])).toUTCString();
										}
										ac.dureePrevisionnelle = ac.duree;
										ac.idQualification = val.id;
										this.updateVolHorairePrevisionnel(ac);
										 
										this.facade.capaciteService.addCapacite(ac).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.AS: {
										let as = new Prestation();
										as.statut = this.prestationStatutEnum.COURS;
										as.beneficiaire = this.prestation.beneficiaire;
										as.statutBeneficiaire = this.prestation.statutBeneficiaire;
										as.typePrestation = this.prestation.typePrestation;
										as.dateDebut = this.prestation.dateDebut;
										as.intervenant = this.prestation.intervenantModule;
										as.service = this.prestation.service;
										as.serviceChefFile = this.prestation.serviceChefFile;
										as.bonCommande = this.prestation.bonCommande;
										as.numeroCommande = this.prestation.numeroCommande;
										as.prescripteur = this.prestation.prescripteur;
										as.prescripteurContact = this.prestation.prescripteurContact;
										as.periode = PeriodeExecutionByType[PrestationType.AS];
										as.duree = DureeExecutionByType[PrestationType.AS];
										if(this.prestation.dateDebut != null){
											let calculatedDateLimite = new Date(this.prestation.dateDebut);
											as.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.AS])).toUTCString();
										}
										as.dureePrevisionnelle = as.duree;
										as.idQualification = val.id;
										this.updateVolHorairePrevisionnel(as);
										 
										this.facade.situationPrestationService.addSituationPrestation(as).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.CAMEO: {
										let cameo = new Prestation();
										cameo.statut = this.prestationStatutEnum.COURS;
										cameo.beneficiaire = this.prestation.beneficiaire;
										cameo.statutBeneficiaire = this.prestation.statutBeneficiaire;
										cameo.typePrestation = this.prestation.typePrestation;
										cameo.dateDebut = this.prestation.dateDebut;
										cameo.intervenant = this.prestation.intervenantModule;
										cameo.service = this.prestation.service;
										cameo.serviceChefFile = this.prestation.serviceChefFile;
										cameo.bonCommande = this.prestation.bonCommande;
										cameo.numeroCommande = this.prestation.numeroCommande;
										cameo.prescripteur = this.prestation.prescripteur;
										cameo.prescripteurContact = this.prestation.prescripteurContact;
										cameo.periode = PeriodeExecutionByType[PrestationType.CAMEO];
										cameo.duree = DureeExecutionByType[PrestationType.CAMEO];
										if(this.prestation.dateDebut != null){
											let calculatedDateLimite = new Date(this.prestation.dateDebut);
											cameo.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.CAMEO])).toUTCString();
										}
										cameo.dureePrevisionnelle = cameo.duree;
										cameo.idQualification = val.id;
										this.updateVolHorairePrevisionnel(cameo);
										 
										this.facade.miseEnOeuvreEmploiService.addMiseEnOeuvreEmploi(cameo).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.EAP: {
										let ev = new Prestation();
										ev.statut = this.prestationStatutEnum.COURS;
										ev.beneficiaire = this.prestation.beneficiaire;
										ev.statutBeneficiaire = this.prestation.statutBeneficiaire;
										ev.typePrestation = this.prestation.typePrestation;
										ev.dateDebut = this.prestation.dateDebut;
										ev.intervenant = this.prestation.intervenantModule;
										ev.service = this.prestation.service;
										ev.serviceChefFile = this.prestation.serviceChefFile;
										ev.bonCommande = this.prestation.bonCommande;
										ev.numeroCommande = this.prestation.numeroCommande;
										ev.prescripteur = this.prestation.prescripteur;
										ev.prescripteurContact = this.prestation.prescripteurContact;
										ev.periode = PeriodeExecutionByType[PrestationType.EAP];
										ev.duree = DureeExecutionByType[PrestationType.EAP];
										if(this.prestation.dateDebut != null){
											let calculatedDateLimite = new Date(this.prestation.dateDebut);
											ev.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.EAP])).toUTCString();
										}
										ev.dureePrevisionnelle = ev.duree;
										ev.idQualification = val.id;
										this.updateVolHorairePrevisionnel(ev);
										 
										this.facade.evaluationService.addEvaluation(ev).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.SP: {
										let sp = new Prestation();
										sp.statut = this.prestationStatutEnum.COURS;
										sp.beneficiaire = this.prestation.beneficiaire;
										sp.statutBeneficiaire = this.prestation.statutBeneficiaire;
										sp.typePrestation = this.prestation.typePrestation;
										sp.dateDebut = this.prestation.dateDebut
										sp.intervenant = this.prestation.intervenantModule;
										sp.service = this.prestation.service;
										sp.serviceChefFile = this.prestation.serviceChefFile;
										sp.bonCommande = this.prestation.bonCommande;
										sp.numeroCommande = this.prestation.numeroCommande;
										sp.prescripteur = this.prestation.prescripteur;
										sp.prescripteurContact = this.prestation.prescripteurContact;
										sp.periode = PeriodeExecutionByType[PrestationType.SP];
										sp.duree = DureeExecutionByType[PrestationType.SP];
										if(this.prestation.dateDebut != null){
											let calculatedDateLimite = new Date(this.prestation.dateDebut);
											sp.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.SP])).toUTCString();
										}
										sp.dureePrevisionnelle = sp.duree;
										sp.idQualification = val.id;
										this.updateVolHorairePrevisionnel(sp);
										 
										this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
								}
							})
						}
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			   break; 
			} 
			case PrestationType.AC: { 
				this.facade.capaciteService.addCapacite(this.prestation).subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			   break; 
			}
			case PrestationType.AS: { 
				this.facade.situationPrestationService.addSituationPrestation(this.prestation).subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			   break; 
			}
			case PrestationType.CAMEO: { 
				this.facade.miseEnOeuvreEmploiService.addMiseEnOeuvreEmploi(this.prestation).subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
				break; 
			}
			case PrestationType.EAP: { 
				this.facade.evaluationService.addEvaluation(this.prestation).subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			   break; 
			}
			case PrestationType.SP: { 
				this.facade.suiviPrecoService.addSuiviPreco(this.prestation).subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
						this.updateListing.emit(this.prestation);
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			   break; 
			}
			default: { 
			   break; 
			} 
		 } 
	}

	updateVolHorairePrevisionnel(prestation : Prestation) : void  {
		if(prestation.dureePrevisionnelle != null && prestation.bonCommande != null){
			prestation.dateAffectBdc = new Date().toISOString().slice(0,10);
			prestation.bonCommande.nombreHeuresPrevisionnelUtil = (prestation.bonCommande.nombreHeuresPrevisionnelUtil != null ? 
				prestation.bonCommande.nombreHeuresPrevisionnelUtil : 0) + prestation.dureePrevisionnelle;
			this.facade.bonCommandeService.updateBonCommande(prestation.bonCommande).subscribe({

			});
		}
	}
}

